import axios from "axios";
// import router from '../router'
axios.default.timeout = 30000;
// axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers.post['content-type'] = 'multipart/form-data'
let currentAxiosConfig = {};
// 拦截请求
const service = axios.create({
  //修改地址需注意 @/utils/upload.js文件下也有地址
  baseURL: "http://mogo.mingruidata.com/",
  timeout: 60000 // request timeout
})
service.interceptors.request.use(
  (config) => {
    // token
    // localStorage.setItem('TOKEN', 'eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkIjoxNjc3NTU0OTYxMzMwLCJleHAiOjQ4MzExNTQ5NjEsImp0aSI6ImIwMDNlMThjZGNhZjRiYjViYjgxYTVhZjdlYTBiNTczIn0.aMUVuMswGDeLhOnjHEa3a_TYm0DMeQZBUUkEHiYGGWonaVYNeAt8I8Bk1_oYg3CEgyt93sxRO_jdCbHFjgSIJQ')
    if (
      localStorage.getItem("DEVICETYPE") !== undefined &&
      localStorage.getItem("DEVICETYPE") !== null
    ) {
      config.headers.DeviceType = localStorage.getItem("DEVICETYPE");
    }
    if (config.url.indexOf("/file/upload’") !== -1) {
      config.headers["content-type"] = "multipart/form-data";
    } else {
      config.headers["content-type"] = "application/json";
    }
    console.time(`[${config.method}]${config.url} 耗时`);
    currentAxiosConfig = config;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// 拦截响应
service.interceptors.response.use(
  (response) => {
    console.timeEnd(
      `[${currentAxiosConfig.method}]${currentAxiosConfig.url} 耗时`
    );
    return response;
  },
  (err) => {
    console.warn("[axios拦截错误] ", err);
    if (err.response) {
      switch (err.response.status) {
        case 401:
          break;
        case 500:
        case 504:
        case 404:
          this.$toast("服务不可用，请稍后再试");
          break;
      }
      err.response.data = err.response.data || {};
      if (typeof err.response.data === "object") {
        err.response.data.code = err.response.status;
      }
      return err.response;
    }
    return Promise.reject(err);
  }
);

// 基地址
// 接口代理地址参见：vue.config.js中的devServer配置
const base = "/admin-service";

// 通用方法
export const POST = (url, params) => {
  return axios.post(`${base}${url}`, params).then((res) => res.data);
};

export const GET = (url, params) => {
  return service.get(`${base}${url}`, { params: params }).then((res) => res.data);
};

export const PUT = (url, params) => {
  return axios.put(`${base}${url}`, params).then((res) => res.data);
};

export const DELETE = (url, params) => {
  return axios
    .delete(`${base}${url}`, { params: params })
    .then((res) => res.data);
};

export const PATCH = (url, params) => {
  return axios.patch(`${base}${url}`, params).then((res) => res.data);
};
